import * as PropTypes from "prop-types";

import CTAButton from "./CTAButton";
import Heading from "./Heading";
import RichText from "./RichText";

const BasicColumn = function ({ data, type = "default" }) {
  const alignmentClass = (function () {
    switch (type) {
      case "default":
        return "self-" + data.vertical_alignment;
      default:
        return "self-" + data.vertical_alignment;
    }
  })();

  return (
    <div className={`rte ${alignmentClass}`}>
      {data.heading?.length ? (
        <Heading field={data.heading} display={data.heading_display} />
      ) : null}
      <RichText field={data.body} />
      <CTAButton className="button-small" field={data} />
    </div>
  );
};

BasicColumn.propTypes = {
  data: PropTypes.object.isRequired,
  type: PropTypes.string,
};

export default BasicColumn;
